import { render } from "./FrequentQuestions.vue?vue&type=template&id=3c8b085a"
import script from "./FrequentQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__